import clsx from 'clsx';
import React from 'react';

import { Image } from 'generated/graphql';

import { getImageUrl } from 'lib/cloudinary';
import { useIsShowroomBasketEnabled, useIsShowroomDowloadOptionEnabled, useIsShowroomMobileVersion } from 'lib/showroom';

import { CircularProgress } from '@material-ui/core';

import ShowroomMediaActions from '../../MediaActions';
import { useStyles } from './styles';

export type ComponentProps = {
	file: Image;
	index: number;
	imageStyle: string;
	position: 'start' | 'center';
};

const ShowroomLayerMedia = (props: ComponentProps) => {
	const { file, index, imageStyle, position } = props;

	const classes = useStyles();
	const downloadEnabled = useIsShowroomDowloadOptionEnabled();
	const basketEnabled = useIsShowroomBasketEnabled();
	const isMobile = useIsShowroomMobileVersion();

	const [loading, setLoading] = React.useState<boolean>(true);

	const imageUrl = getImageUrl(file.cloudinaryId, {
		quality: 'auto:good',
		version: file.cloudinaryVersion.toString(),
		fetchFormat: 'auto',
		width: 1000,
		crop: 'scale'
	});
	const isLandscape = file.width > file.height;

	const mediaContent = React.useMemo(() => {
		return (
			<div className={classes.imageItem} style={{ alignItems: position }}>
				<img
					id={`${file.mediaType}_${file.cloudinaryId}_${index}_img`}
					className={clsx(imageStyle, {
						[classes.imageItemPortrait]: !isLandscape
					})}
					src={imageUrl}
					style={{ zIndex: 1 }}
					alt=""
					draggable={false}
					onContextMenu={ev => ev.preventDefault()}
					onLoad={() => setLoading(false)}
				></img>
				{isMobile && <div className={classes.linearOverlay} />}
				{loading && <CircularProgress id={`imageLoader_${file.id}`} className={classes.loader} />}
			</div>
		);
	}, [classes, position, file, index, imageStyle, isLandscape, imageUrl, loading, isMobile]);

	return downloadEnabled || basketEnabled ? <ShowroomMediaActions media={file}>{mediaContent}</ShowroomMediaActions> : mediaContent;
};

export default React.memo(ShowroomLayerMedia);
